export class ListInfectedSnapshotsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<SnapshotReference>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInfectedSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
